

export class Config {
    public screen: { aspectRatio: number; pixelRatio: number; width: number; height: number };

    constructor() {
        const width = window.innerWidth;
        const height = window.innerHeight;

        this.screen = {
            aspectRatio: height / width,
            pixelRatio: Math.min(Math.max(window.devicePixelRatio, 1), 2),
            width,
            height,
        };
    }
}
const config = new Config();

export default config;
